module.exports = __webpack_public_path__ + "static/media/42_tn.4b968afc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/42_tn.jpg
// module id = 351
// module chunks = 0